import { Fragment } from 'react';

/** Renders an email with soft break opportunities after '@' and before each '.', so it wraps as 'jordan.lee@' / 'acmecorp.com' instead of mid-word. */
export function BreakableEmail({ email }: { email: string }) {
    const parts = email.split(/(?<=@)|(?=\.)/);
    return (
        <>
            {parts.map((part, index) => (
                <Fragment key={`${index}-${part}`}>
                    {index > 0 ? <wbr /> : null}
                    {part}
                </Fragment>
            ))}
        </>
    );
}
